import { notification } from 'antd';
import { useTranslation } from 'react-i18next';
import { dateHelpers } from 'utils/helpers/dateHelpers';

export const useDateValidation = () => {
    const { t } = useTranslation();

    const isValidDateRange = (
        startDate: string | undefined,
        endDate: string | undefined,
        errorMessageKey: string = 'common.form_error.dateTo_wrong',
    ): boolean => {
        if (startDate && endDate) {
            const isEndDateAfterStartDate = dateHelpers.isEndDateAfterStartDate(
                endDate,
                startDate,
            );

            if (!isEndDateAfterStartDate) {
                notification.error({
                    message: t(errorMessageKey),
                });
                return false;
            }
        }

        return true;
    };

    return { isValidDateRange };
};
